import { StyleSheet } from 'react-native';
import { ThemeColors } from '../../../common/theme-colors';
import theme from '../../../common/theme';

export const getStyles = (colors: ThemeColors) =>
  StyleSheet.create({
    container: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
      rowGap: 32,
      padding: 60,
      paddingBottom: 0,
      backgroundColor: colors.elevation1,
    },
    btnClose: {
      position: 'absolute',
      top: 16,
      left: 16,
    },
    title: {
      fontSize: 28,
      lineHeight: 44,
      color: colors.text,
      textAlign: 'center',
      fontFamily: theme.fonts.bold,
    },
    listWrapper: {
      flex: 1,
      alignSelf: 'stretch',
    },
    maskTop: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
    },
    maskBottom: {
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      transform: [{ rotate: '180deg' }],
    },
    list: {
      flexGrow: 1,
    },
    listContent: {
      alignItems: 'center',
      gap: 8,
      paddingTop: 32,
      paddingBottom: 120,
    },
    listRow: {
      justifyContent: 'center',
      gap: 8,
    },
    option: {
      width: 200,
      flexDirection: 'row',
      alignItems: 'center',
      columnGap: 12,
      padding: 16,
      borderRadius: theme.radius.m,
      backgroundColor: colors.elevation0,
      borderWidth: 1,
      borderColor: colors.border,
    },
    optionSelected: {
      borderColor: colors.neutral,
      backgroundColor: colors.neutralXL,
    },
    optionText: {
      fontSize: 16,
      lineHeight: 22,
      color: colors.text,
      fontFamily: theme.fonts.medium,
    },
  });
